import { COUNTRIES_BY_CODE } from "@redotech/locale/countries";
import { Condition } from "@redotech/redo-model/return-flow/condition";
import {
  customerAddressFromModel,
  validateCustomerAddressCondition,
  type CustomerAddressState,
} from "@redotech/redo-model/return-flow/condition-validate";
import * as React from "react";
import { ConditionType, ConditionTypeDetailsProps } from "../condition";

export const CUSTOMER_ADDRESS = (
  Details: React.ComponentType<ConditionTypeDetailsProps<CustomerAddressState>>,
): ConditionType<CustomerAddressState, Condition.CustomerAddress> => ({
  name: "Customer address",
  description(state) {
    if (!state.country) {
      return "No country selected";
    }
    const countryName = COUNTRIES_BY_CODE[state.country] || state.country;
    const regionLabel = state.country === "US" ? "state" : "province";
    if (state.provinceCodes.length === 0) {
      return `${countryName}: No ${regionLabel}s selected`;
    }
    return `${countryName}: ${state.provinceCodes.length} ${regionLabel}(s) selected`;
  },
  Details(props: ConditionTypeDetailsProps<CustomerAddressState>) {
    return React.createElement(Details, props);
  },
  empty: { country: "", provinceCodes: [] },
  fromModel(model) {
    return customerAddressFromModel(model);
  },
  toModel(state) {
    return {
      type: Condition.CUSTOMER_ADDRESS,
      country: state.country,
      provinceCodes: state.provinceCodes,
    };
  },
  valid(state) {
    return validateCustomerAddressCondition(state).valid;
  },
});

export { type CustomerAddressState } from "@redotech/redo-model/return-flow/condition-validate";
